import { type Message } from "shared/apiClient";
import { type Noticeboard } from "shared/lib";

import {
  getReportLoadingProgressIndicatorItems,
  type ProgressIndicatorItemMap,
} from "@/lib/reportLoader";

import { PermitRequirementsLoader } from "./PermitRequirementsLoader";

export interface PermitRequirementsLoaderContainerProps {
  latestUserMessage?: Message;
  noticeboardData: Noticeboard | undefined | null;
  progressIndicatorItemMap: ProgressIndicatorItemMap;
  title: string;
}

export function PermitRequirementsLoaderContainer({
  latestUserMessage,
  noticeboardData,
  progressIndicatorItemMap,
  title,
}: PermitRequirementsLoaderContainerProps) {
  return (
    <PermitRequirementsLoader
      items={getReportLoadingProgressIndicatorItems(
        noticeboardData || {},
        parseInt(latestUserMessage?.message_number || "-999"),
        progressIndicatorItemMap,
      )}
      title={title}
    />
  );
}
